import { z } from 'zod';

export const createWebhookFormSchema = z.object({
  url: z
    .string()
    .min(1, 'URL is required')
    .url('Enter a valid URL')
    .refine((value) => value.startsWith('https://'), {
      message: 'URL must use https://',
    }),
  label: z.string().max(100, 'Label must be 100 characters or fewer'),
});

export type CreateWebhookFormValues = z.infer<typeof createWebhookFormSchema>;
